import React, { useEffect, useState } from 'react'
import { Field } from '@arnsbogroup/react-voicearchive'
import classNames from 'classnames'
import TimeRangePicker from '@wojtekmaj/react-timerange-picker/dist/entry.nostyle';
import './css/timeRange.css'; 
const TimeRangePickerElement = ({ 
    innerRef,
    errors,
    className,
    onChange = () => {},
    getTimestamp,
    ...props 
}) => {
    const [from, setFrom] = useState(null)
    const [to, setTo] = useState(null)

    const getNewDateTimestamp = (value) => {
        if (!value.every(val => val == null)) {
            let returnTimestamp = [];
            if (value && getTimestamp && typeof value == 'object') {
                returnTimestamp = value.map((strTime) => {
                    if (strTime) {
                        let now = new Date()
                        const valueArr = strTime.split(':')
                        now.setHours(valueArr[0]);
                        now.setMinutes(valueArr[1]);
                        return Math.floor(now / 1000)
                    }
                });
            }
            
            const returnValue = getTimestamp ? returnTimestamp : value
            if (returnValue[0]) {
                setFrom(returnValue[0])
            }
            if (returnValue[1]) {
                setTo(returnValue[1])
            }
        }
    }
    const handleBlur = () => {
        if (from && to) {
            onChange([from, to])
        }
    };

    return (
        <TimeRangePicker
            disableClock
            clearIcon={null}
            hourPlaceholder="hh"
            minutePlaceholder="mm"
            className={classNames([
                'w-full',
                'p-4',
                'transition',
                'duration-200',
                'border',
                'peer',
            ], {
                'border-gray-300 focus:border-primary': !errors.length,
                'border-negative': !!errors.length,
            }, className)}
            onBlur={handleBlur}
            onChange={(value) => {
                getNewDateTimestamp(value);
            }} 

            ref={innerRef}
            { ...props }
        />
    )
}

export const TimeRange = (props) => (
    <Field {...props} element={TimeRangePickerElement} />
)

export default TimeRange
